export default "__VITE_ASSET__Do2OHqRc__"